/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Describes a module type for a task box
 * @export
 */
export const TaskModuleTypeEnum = {
    None: 'None',
    Patient: 'Patient',
    Accounting: 'Accounting',
    Stock: 'Stock',
    Staff: 'Staff',
    Learning: 'Learning',
    Teaching: 'Teaching',
    Research: 'Research'
} as const;
export type TaskModuleTypeEnum = typeof TaskModuleTypeEnum[keyof typeof TaskModuleTypeEnum];


export function instanceOfTaskModuleTypeEnum(value: any): boolean {
    for (const key in TaskModuleTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(TaskModuleTypeEnum, key)) {
            if (TaskModuleTypeEnum[key as keyof typeof TaskModuleTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaskModuleTypeEnumFromJSON(json: any): TaskModuleTypeEnum {
    return TaskModuleTypeEnumFromJSONTyped(json, false);
}

export function TaskModuleTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskModuleTypeEnum {
    return json as TaskModuleTypeEnum;
}

export function TaskModuleTypeEnumToJSON(value?: TaskModuleTypeEnum | null): any {
    return value as any;
}

export function TaskModuleTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TaskModuleTypeEnum {
    return value as TaskModuleTypeEnum;
}

